import _ from "lodash";
import dayjs from "dayjs";
import {
  cinNumberValidation,
  panNumbervalidation,
} from "../../../components/functions/formValidation";
import { validationErrorTypes } from "../../../interfaces/interfaces";

export const directorSelectOptionValidation = (value) => {
  if (!value) {
    return "Select an Option";
  }
  return "";
};

export const requiredTextValidation = (value, message: string) => {
  if (!value || !String(value).trim()) {
    return message;
  }
  return "";
};

export const panValidation = (value, requiredMessage: string) => {
  const error = panNumbervalidation(value);
  if (error == validationErrorTypes.required) {
    return requiredMessage;
  }
  if (error == validationErrorTypes.invalid) {
    return "Enter a valid PAN";
  }
  return "";
};

export const cinValidation = (value) => {
  const error = cinNumberValidation(value);
  if (error == validationErrorTypes.required) {
    return "Enter company's CIN";
  }
  if (error == validationErrorTypes.invalid) {
    return "Enter a valid CIN";
  }
  return "";
};

export const pastDateValidation = (value, requiredMessage: string) => {
  if (!value) {
    return requiredMessage;
  }
  if (!dayjs(value).isValid()) {
    return "Enter a valid date";
  }
  if (dayjs(value).isAfter(dayjs(), "day")) {
    return "Enter a date from the past or today";
  }
  return "";
};

export const directorFields = [
  {
    key: "name",
    validatorFunc: (value) => requiredTextValidation(value, "Enter director's name"),
  },
  {
    key: "pan",
    validatorFunc: (value) => panValidation(value, "Enter director's PAN"),
  },
  {
    key: "dob",
    validatorFunc: (value) => pastDateValidation(value, "Enter director's date of birth"),
  },
  {
    key: "address",
    validatorFunc: (value) => requiredTextValidation(value, "Enter director's address"),
  },
];

export const validateDirectorFields = (values) => {
  const missingData = [];

  const directorsArr = values?.directors ?? [];
  if (!directorsArr.length) {
    missingData.push("Add at least one director");
  }

  const directorsError = directorsArr.map((item) => {
    const directorErrorsObj = {};
    directorFields.forEach((field) => {
      const error = field.validatorFunc(_.get(item, field.key));
      if (error) {
        _.set(directorErrorsObj, field.key, error);
        missingData.push(error);
      }
    });
    return directorErrorsObj;
  });

  return {
    errors: {
      directors: directorsError,
    },
    missingData,
  };
};
